var map = {
	"./632100D4778F2AD0.png": 340,
	"./Durham_stamp.svg": 341,
	"./bid-icon-pink.svg": 342,
	"./bid-icon-white.svg": 343,
	"./bid-icon.svg": 344,
	"./giftcard.png": 345,
	"./in-logo-black.png": 346,
	"./in-logo.png": 347,
	"./independent-logo.png": 348,
	"./leicester-icon.svg": 349,
	"./location_07_brand.svg": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 339;